export const GLOBAL = {
  WIDTH: 800,
  HEIGHT: 300,
  THEME_COLOR: "#ffb24c"
}